/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import Avatar from '@atlaskit/avatar/avatar';
import { AvatarContent } from '@atlaskit/avatar/avatar-content';
import { css, jsx } from '@atlaskit/css';
import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import { token } from '@atlaskit/tokens';

const styles = {
	iconContainer: css({
		display: 'grid',
		height: '100%',
		backgroundColor: token('elevation.surface'),
		placeItems: 'center',
	}),
};

function AvatarContentExample(): JSX.Element {
	return (
		<Avatar size="large" borderColor={token('color.background.brand.bold')}>
			<AvatarContent>
				<div css={styles.iconContainer}>
					<PeopleGroupIcon label="More users" />
				</div>
			</AvatarContent>
		</Avatar>
	);
}

export default AvatarContentExample;
